import { render, staticRenderFns } from "./ProjectExtended.vue?vue&type=template&id=d711b3a4&"
import script from "./ProjectExtended.vue?vue&type=script&lang=js&"
export * from "./ProjectExtended.vue?vue&type=script&lang=js&"
import style0 from "./ProjectExtended.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectExtended.vue"
export default component.exports